import {NuxtIcon} from "#components";
import {h} from "vue";
import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "svg-SQ-logo_svg__svg2",
  viewBox: "0 0 92.54 128.3"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(".svg-SQ-logo_svg__cls-1{fill:#fcb130;fill-rule:evenodd}", -1)
        ]))]),
        _: 1
      }))
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("g", { id: "svg-SQ-logo_svg__g4758" }, [
      _createElementVNode("path", {
        id: "svg-SQ-logo_svg__path52",
        d: "M28.97 117.48h-8.91l17.99-28.39s2.69-5.88-.83-12.1L12.14 35.47s-2.19-3.86 0-7.54l7.42-11.11 29.42 48.07s7.58 10.07-.66 22.54l-19.35 30.04",
        class: "svg-SQ-logo_svg__cls-1"
      }),
      _createElementVNode("path", {
        id: "svg-SQ-logo_svg__path54",
        d: "m50.48 108.78 10.94-16.66s3.19-6.88 11.44-6.88h11.6L92.54 98s-6.38-.66-9.24 3.9l-11.93 17.98s-3.9 8.41-14.3 8.41H.87l21.38-32.82s3.02-3.85-1.2-10.24L2.03 54.66s-4.68-4.52.17-12.27l5.55-8.41 26.44 42.85s4.68 5.89 0 12.93l-19.85 30.96H56.2s4.72.87 8.78-5.18l10.4-16s2.36-5.39 7.58-7.58h-8.41s-4.39.17-7.75 5.39l-9.24 14.3s-3.36 6.05-10.78 6.05H32.15L49.8 90.31s9.61-12.64 2.86-24.24L23.42 17.65s-2.19-4.19.33-8.08L30.13 0l33.32 53.66s4.89 8.04 4.89 14.26-3.9 13.26-6.05 16.82l-14.67 22.87s-1.66 2.2-.5 3.03c1.2.83 2.36-.66 3.36-1.87",
        class: "svg-SQ-logo_svg__cls-1"
      })
    ], -1))
  ]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "SQ-logo"}) } }